import Image from 'next/image'

const Loader = props => (
  <div className='container'>
    <div className='load text-center'>
      <Image
        width={16}
        height={11}
        src='/static/images/ajax-loader.gif'
        alt='Carregando'
        className='top'
      />
      <p>{props.text}</p>
    </div>
  </div>
)

export default Loader
